import classNames from 'classnames';
import React, { useMemo } from 'react';

import {
  DerivativesOrderSide,
  DerivativesOrderType,
  DerivativesPositionSide,
} from 'common/api/autogenerated/trading-gateway';

import { useI18n } from 'common/hooks';

import { isBuy as isBuyHelper, isSell as isSellHelper } from '../utils';

const SideLabelComponent: React.FC<
  React.PropsWithChildren<{
    isColumn: boolean;
    side?: DerivativesOrderSide | DerivativesPositionSide;
    type?: DerivativesOrderType;
  }>
> = (props) => {
  const { translateToText } = useI18n();

  const isBuy = useMemo(() => isBuyHelper(props.side), [props.side]);
  const isSell = useMemo(() => isSellHelper(props.side), [props.side]);

  const wrapperClassName = classNames({
    'derivative-order-pair-info__side': true,
    'derivative-order-pair-info__side--column': props.isColumn,
  });

  const valueClassName = classNames({
    'derivative-order-pair-info__side--buy': isBuy,
    'derivative-order-pair-info__side--sell': isSell,
  });

  const directionLabel = useMemo(
    () => translateToText(`mobile:derivative:open-orders:card:direction:${props.side}`),
    [props.side, translateToText],
  );

  const orderTypeLabel = useMemo(
    () => translateToText(`mobile:derivative:open-orders:card:order-type:${props.type?.toLowerCase()}`),
    [props.type, translateToText],
  );

  if (!props.side) return null;

  return (
    <div className={wrapperClassName}>
      <span className={valueClassName}>{directionLabel}</span>
      {props.type && <span>{orderTypeLabel}</span>}
    </div>
  );
};

export default React.memo(SideLabelComponent);
